import React from 'react'
import "./main.css"

import Двухстворчатое from '../../images/Special Offer/Двухстворчатое.png'
import Трехстворчатое from '../../images/Special Offer/Трехстворчатое.png'
import Балконный from '../../images/Special Offer/Балконный.png'

export default function SpecialOffer() {
    return (
        <>
            <div className="special-offer">
                <h1 className='title'>Специальное предложение</h1>
                <div className="header-fon"></div>
                <div className="main-circle"></div>
                <div className="footer-fon"></div>
                <header>
                    <div className="header-box">
                        <h2 className='header-title'>Двухстворчатое окно</h2>
                        <img src={Двухстворчатое} alt="error" />
                        <p className='beffore-summ'>
                            <del>7 018 руб.</del>
                        </p>
                        <h2 className='after-summ'>4 742 руб.</h2>
                        <hr />
                        <p className='rasrochka-summ'>Расрочка за 791 р/мес.</p>
                        <button>Заказать сейчас</button>
                    </div>
                    <div className="header-box">
                        <h2 className='header-title'>Трехстворчатое окно</h2>
                        <img src={Трехстворчатое} alt="error" />
                        <p className='beffore-summ'>
                            <del>7 018 руб.</del>
                        </p>
                        <h2 className='after-summ'>4 742 руб.</h2>
                        <hr />
                        <p className='rasrochka-summ'>Расрочка за 791 р/мес.</p>
                        <button>Заказать сейчас</button>
                    </div>
                    <div className="header-box">
                        <h2 className='header-title'>Балконный блок</h2>
                        <img src={Балконный} className='balkon' alt="error" />
                        <p className='beffore-summ sum'>
                            <del>7 018 руб.</del>
                        </p>
                        <h2 className='after-summ'>4 742 руб.</h2>
                        <hr />
                        <p className='rasrochka-summ'>Расрочка за 791 р/мес.</p>
                        <button>Заказать сейчас</button>
                    </div>
                </header>
            </div>
        </>
    )
}
